import { IFilter } from '../../types/filters';
import { RepairContainer } from '../../containers/advancedFilters/RepairContainer';

export const repair: IFilter = {
  component: RepairContainer,
};
